import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const getMarkets = async (category) => {
  const { data } = await client.get("/markets", {
    params: category ? { category } : {},
  });
  return data;
};

export const getMovers = async () => (await client.get("/markets/movers")).data;

export const getMood = async () => (await client.get("/markets/mood")).data;

export const getAsset = async (symbol) =>
  (await client.get(`/markets/${symbol}`)).data;

export const getHistory = async (symbol, period) =>
  (await client.get(`/markets/${symbol}/history`, { params: { period } })).data;

export const getFx = async () => (await client.get("/config/fx")).data;

export const getAssetConfig = async () =>
  (await client.get("/config/assets")).data;
